import {Outlet} from 'react-router-dom';
import {TabNavLinks} from '@tinct/web-components';
import {LayoutContent, LayoutHeader, LayoutTopbar} from "@tinct/web-layout";
import {useGetUserForAccountSettingsPage} from "./hooks/use-get-user-for-account-settings-page";
import {useConnectedUser} from "@tinct/core-store-session";
import {EditUserOutletContext} from "./types";

const getTabItems = (baseUrl: string) => [
  { title: 'Profile', url: `${baseUrl}/account/profile` },
  { title: 'Security', url: `${baseUrl}/account/security` },
  { title: 'Preferences', url: `${baseUrl}/account/preferences` },
];

export function AccountSettingsPage({baseUrl} : {baseUrl: string}) {
  const connectedUser = useConnectedUser();
  const connectedUserId = connectedUser?.id as string;
  const { user, isLoading } =
    useGetUserForAccountSettingsPage(connectedUserId);

  const outletContext: EditUserOutletContext = {
    user,
    isLoading,
  };

  if(!user) {
    return <div>User not found</div>;
  }

  const displayName = user.firstName ?? 'My account';

  return (
    <div>
      <header className="sticky top-0 z-30">
        <LayoutTopbar />
      </header>
      <LayoutContent className={'gap-8'}>
        <LayoutHeader
          pageTitle={displayName}
        />
        <TabNavLinks items={getTabItems(baseUrl)} />
        <div className="flex flex-col h-full  max-w-4xl">
          <div className="flex-1">
            <Outlet context={outletContext} />
          </div>
        </div>
      </LayoutContent>
    </div>
  );
}
